import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { IMenuItem } from '@app/xenial-ux/interfaces';

@Component({
  selector: 'xux-menu-item',
  templateUrl: './xux-menu-item.component.html',
  styleUrls: ['./xux-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XUXMenuItemComponent implements OnInit {
  @ViewChild('popover', { static: false }) public popover: any;
  @Input() public depth: number;
  @Input() public item: IMenuItem;
  @Output() public onTogglePin: EventEmitter<any> = new EventEmitter();
  public exactActive: boolean = true;
  public constructor() {}

  public ngOnInit(): void {}

  public togglePin(payload: any): void {
    this.onTogglePin.emit({ menuItem: payload.menuItem, event: payload.event });
  }

  public clickPin(menuItem: IMenuItem, event: Event): boolean {
    this.onTogglePin.emit({ menuItem, event });
    event.stopPropagation();

    return false; // prevent pin click from hitting anchor
  }

  public toggleSubmenu(item?: IMenuItem): void {
    this.item.isOpen = !item.isOpen;
  }

  /**
   * @param event
   * @description hover over run pop flyout menu
   */
  public mouseEnter(event: Event): void {
    const hoverElement = event.target as HTMLInputElement;
    const popover = hoverElement.querySelector<HTMLElement>('.popover-wrapper');
    if (popover) {
      // hide element with opacity so it isn't visible before position is set
      popover.style.opacity = '0';
      popover.style.display = 'block';
      // timeout is needed because the element doesn't have height while hidden
      setTimeout(() => {
        const hoverElementBounds = hoverElement.getBoundingClientRect();
        const popoverHeight = popover.offsetHeight;
        let newPopoverTop = hoverElementBounds.top - popoverHeight * 0.5 + 18;
        if (newPopoverTop + popoverHeight > window.innerHeight) {
          newPopoverTop = window.innerHeight - popoverHeight;
        }
        // don't position above top of page
        newPopoverTop = Math.max(newPopoverTop, 0);
        popover.style.top = `${newPopoverTop}px`;
        popover.style.left = `${hoverElementBounds.left + hoverElementBounds.width - 20}px`;
        // show the popover now that it is positioned correctly
        popover.style.opacity = '1';
      }, 100);
    }
  }

  public mouseLeave(event: Event): void {
    if (event) {
      const hoverElement = event.target as HTMLInputElement;
      const popover =
        hoverElement.querySelector<HTMLElement>('.popover-wrapper');
      if (popover) {
        popover.style.display = 'none';
      }
      event.stopPropagation();
    }
  }

  public trackByRoute(index: number, item: IMenuItem): string {
    return item.route;
  }
}
